import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGreyIconLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-label": "Analytics icon",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 8,
		cy: 8,
		r: 6.5,
		stroke: "#CF5300",
		strokeWidth: 1,
		fill: "none"
	}), /* @__PURE__ */ _jsxs("g", {
		fill: "#CF5300",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				x: 4,
				y: 9,
				width: 1.2,
				height: 3,
				rx: .5
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 5.8,
				y: 8,
				width: 1.2,
				height: 4,
				rx: .5
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 7.6,
				y: 7,
				width: 1.2,
				height: 5,
				rx: .5
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 9.4,
				y: 6,
				width: 1.2,
				height: 6,
				rx: .5
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 11.2,
				y: 5,
				width: 1.2,
				height: 7,
				rx: .5
			})
		]
	})]
});
export default SvgGreyIconLogo;
